import React from 'react';
import {CreateGuesser} from "@api-platform/admin";

const ChannelCreate = props => (
        <CreateGuesser {...props} resource="channels"/>
);

export default ChannelCreate;
